import { gameState, MAX_BARS } from '../services/gameState.js';
import { sound } from '../services/audioService.js';

export class StatsView {
  constructor(containerElement, onPlayStatCallback) {
    this.container = containerElement;
    this.onPlayStat = onPlayStatCallback;
    this.cachedHtml = '';
    this.selectedStatForModal = null;
  }

  formatTime(seconds) {
    if (seconds <= 0) return 'decaying...';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (h > 0) {
      return `${h}h ${m}m ${s < 10 ? '0' : ''}${s}s`;
    }
    if (m > 0) {
      return `${m}m ${s < 10 ? '0' : ''}${s}s`;
    }
    return `${s}s`;
  }

  render(state) {
    const statKeys = Object.keys(state.stats);
    let html = '';

    statKeys.forEach((key) => {
      const stat = state.stats[key];
      const barsCount = stat.bars;
      const isFull = barsCount === MAX_BARS;
      const isEmpty = barsCount === 0;

      // Render 9 discrete segmented life bars
      let segmentsHtml = '';
      for (let i = 0; i < MAX_BARS; i++) {
        const isFilled = i < barsCount;
        segmentsHtml += `<div class="life-segment ${isFilled ? 'filled' : ''}" style="--segment-color: ${stat.color};"></div>`;
      }

      let timerText = '';
      if (isFull) {
        timerText = `⚡ Full (${barsCount}/${MAX_BARS})`;
      } else if (isEmpty) {
        timerText = `⚠️ Depleted (0/${MAX_BARS})!`;
      } else {
        timerText = `⏳ -1 in ${this.formatTime(stat.secondsToNextDecay)} (${barsCount}/${MAX_BARS})`;
      }

      html += `
        <div class="stat-card" data-stat-id="${stat.id}">
          <div class="stat-left">
            <div class="stat-icon-bubble" style="background: ${stat.bgGradient}">
              ${stat.icon}
            </div>
            <div class="stat-info">
              <div class="stat-header-row">
                <span class="stat-name">${stat.name}</span>
                <span class="stat-decay-timer" style="${isEmpty ? 'color: #FF5252; font-weight: 700;' : ''}">${timerText}</span>
              </div>
              <div class="nine-bars-container">
                ${segmentsHtml}
              </div>
            </div>
          </div>
          <button class="play-game-btn" data-play-stat="${stat.id}" style="background: ${stat.bgGradient}">
            <span>Play</span>
            <span style="font-size: 10px;">▶</span>
          </button>
        </div>
      `;
    });

    this.container.innerHTML = html;

    // Attach click listeners to Play buttons
    const playButtons = this.container.querySelectorAll('[data-play-stat]');
    playButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        sound.playClick();
        const statId = btn.getAttribute('data-play-stat');
        if (this.onPlayStat) {
          this.onPlayStat(statId);
        }
      });
    });
  }
}
